/**
* Planetarium Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Planetarium Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'planetarium-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.planetarium-callout' ).each( function() {
        const planetImageSize = 434;
        const jupiterDesktopWrapper = $( this ).find( '.jupiter-wrapper-desktop' )[0];
        const jupiterMobileWrapper = $( this ).find( '.jupiter-wrapper-mobile' )[0];
        const jupiterDesktop = $( this ).find( '.jupiter-desktop' )[0];
        const jupiterMobile = $( this ).find( '.jupiter-mobile' )[0];
        const saturn = $( this ).find( '.saturn' )[0];
        const frameCount = 12;
        const offsetValue = ( planetImageSize / 2 );

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          gsap.to( jupiterDesktop, {
            backgroundPosition: '0 ' + ( planetImageSize * frameCount ) + 'px',
            ease: 'steps(' + frameCount + ')', // use a stepped ease for the sprite sheet
            scrollTrigger: {
              trigger: this,
              start: '50% bottom',
              end: 'bottom 25%',
              // markers: true,
              scrub: true,
            },
          } );

          gsap.to( jupiterMobile, {
            backgroundPosition: '0 ' + ( planetImageSize * frameCount ) + 'px',
            ease: 'steps(' + frameCount + ')', // use a stepped ease for the sprite sheet
            scrollTrigger: {
              trigger: this,
              start: '50% bottom',
              end: 'bottom 25%',
              // markers: true,
              scrub: true,
            },
          } );

          gsap.to( saturn, {
            y: '10%',
            ease: 'linear',
            scrollTrigger: {
              trigger: this,
              start: '25% bottom',
              end: 'bottom 0%',
              // markers: true,
              scrub: true,
            },
          } );

          gsap.to( jupiterDesktopWrapper, {
            y: '-15%',
            ease: 'linear',
            scrollTrigger: {
              trigger: this,
              start: '50% bottom',
              end: 'bottom 25%',
              // markers: true,
              scrub: true,
            },
          } );

          gsap.to( jupiterMobileWrapper, {
            y: '-15%',
            ease: 'linear',
            scrollTrigger: {
              trigger: this,
              start: '50% bottom',
              end: 'bottom 25%',
              // markers: true,
              scrub: true,
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'planetarium-callout', COMPONENT );
} )( app );
